import { Modal, ModalBody, ModalFooter, ModalHeader, ROLE } from 'baseui/modal'
import React, { useContext } from 'react'
import { ButtonType, CustomButton, InputWrapper } from '../../../components'
import { getUserUuidFromLocalStorage } from '../../../utils'
import { WemoloDropdown } from '../../../components/Wemolo'
import { DeviceContext } from '../DeviceContext'
import { SmsResponses } from './SmsResponses'
import { useSendSmsCommandMutation } from './useSmsHooks'
import * as Sentry from '@sentry/react'
import styles from './SendCommand.module.css'

export const SendCommand = () => {
    const { sendSmsCommand, loading: loadingSendSms } = useSendSmsCommandMutation()
    const deviceContext = useContext(DeviceContext)
    const [selectedCommand, setSelectedCommand] = React.useState({
        label: 'router_reboot',
        id: 'router_reboot'
    })
    const [openModal, setOpenModal] = React.useState(false)
    return (
        <div className={styles.root}>
            <Modal
                onClose={() => {
                    setOpenModal(false)
                }}
                closeable
                isOpen={openModal}
                animate
                autoFocus
                size={'80vw'}
                role={ROLE.alertdialog}
            >
                <ModalHeader>SMS Responses</ModalHeader>
                <ModalBody>
                    <SmsResponses />
                </ModalBody>
                <ModalFooter>
                    <CustomButton
                        type={ButtonType.DELETE}
                        onClick={() => {
                            setOpenModal(false)
                        }}
                    >
                        Close
                    </CustomButton>
                </ModalFooter>
            </Modal>
            <div className={styles.fullWidth}>
                <InputWrapper label="Choose SMS command">
                    <div className={styles.inputRow}>
                        <div className={styles.dropdownWrapper}>
                            <WemoloDropdown
                                size="medium"
                                placeholder="Select command"
                                options={[
                                    { label: 'router_reboot', value: 'router_reboot' },
                                    { label: 'router_status', value: 'router_status' },
                                    { label: 'router_rms_connect', value: 'router_rms_connect' },
                                    { label: 'power_cycle_nano_camera', value: 'power_cycle_nano_camera' }
                                ]}
                                value={selectedCommand?.id}
                                onChange={(id) => {
                                    if (id) setSelectedCommand({ label: id, id })
                                }}
                            />
                        </div>
                        &nbsp;&nbsp;
                        <div className={styles.buttonsGroup}>
                            <CustomButton
                                isLoading={loadingSendSms}
                                disabled={loadingSendSms}
                                onClick={() => {
                                    if (!deviceContext.deviceData?.uuid) return
                                    Sentry.logger.info('sms_command.sent', {
                                        event: 'sms_command_sent',
                                        command: selectedCommand.id,
                                        deviceUuid: deviceContext.deviceData.uuid,
                                        userId: getUserUuidFromLocalStorage()
                                    })
                                    sendSmsCommand({
                                        device_uuid: deviceContext.deviceData.uuid,
                                        command: selectedCommand.id
                                    })
                                }}
                            >
                                Send
                            </CustomButton>
                            <CustomButton
                                onClick={() => {
                                    setOpenModal(true)
                                }}
                            >
                                <>
                                    <i className={`material-icons ${styles.iconMessage}`}>message</i> &nbsp;&nbsp; View
                                    SMS Responses
                                </>
                            </CustomButton>
                        </div>
                    </div>
                </InputWrapper>
            </div>
        </div>
    )
}
